import React from 'react';
import { object } from 'prop-types';
import { Link } from 'react-router-dom';
import { get, map, includes, forEach } from 'lodash';
import { FlexContainer, Row, Column, Text, CounterButton } from '../../common';

const SlaCardMobile = ({ data, selectedSalesChannels, dateRange, ...props }) => {
    const statuses = [
        { key: 'pendientePicking', label: 'Pendiente picking' },
        { key: 'inPicking', label: 'En picking' },
        { key: 'pendienteAuditoria', label: 'Pendiente auditoría' },
        { key: 'pendienteFacturacion', label: 'Pickeado por facturar' },
        { key: 'errorFacturar', label: 'Error facturar' },
        { key: 'facturado', label: 'Facturado' },
        { key: 'anulado', label: 'Anulado' }
    ];

    const getColumSlas = (column) => {
        const values = {
            total: '',
            despacho: 'express,domicilio,especial',
            retiro: 'tienda,auto'
        };
        return values[column];
    };

    const getStatuses = (row) => {
        switch (row) {
            case 'pendientePicking':
                return '1-2-7-20';
            case 'inPicking':
                return '3-6';
            case 'pendienteAuditoria':
                return '30-32';
            case 'pendienteFacturacion':
                return '4-8';
            case 'errorFacturar':
                return '9';
            case 'facturado':
                return '5-50-51-53-54-55-56-57-58-59-60';
            case 'anulado':
                return '41';
            default:
                return '';
        };
    };

    const getMobileValues = items => {
        const values = { despacho: {}, retiro: {}, total: {}, id: get(items, 'id', '0') };
        forEach(items, (slaStatuses, slaIndex) => {
            const setStatusValue = index => forEach(slaStatuses, (statusValue, statusIndex) => {
                values[index][statusIndex] = (values[index][statusIndex] || 0) + statusValue;
            });
            switch (slaIndex) {
                case 'resume':
                    setStatusValue('total');
                    break;
                case 'despachoDomicilio':
                case 'despachoExpress':
                    setStatusValue('despacho');
                    break;
                case 'clickAlAuto':
                case 'retiroEnTienda':
                    setStatusValue('retiro');
                    break;
                default:
                    break;
            };
        });
        return values;
    };

    const counterUrl = ({ id, row, column }) => {
        const url = sc => `selectedSla=${getColumSlas(column)}&status=${getStatuses(row)}&salesChannel=${sc || ''}&range=${dateRange || ''}`;
        if (id === '0') return `${url(map(selectedSalesChannels, 'value'))}`;
        return `${url(id)}`;
    };

    return (
        <FlexContainer
            direction='column'
            width='100%'
        >
            <Row
                style={{
                    backgroundColor: '#c0c0c0',
                    margin: '5px 5px 0 5px',
                    borderTopRightRadius: '3px',
                    borderTopLeftRadius: '3px',
                    padding: '3px 5px'
                }}
            >
                { map(['Resumen', 'Retiro', 'Despacho', 'Total'], (column) => {
                    const conditionalValue = (yes, not) => includes([column], 'Resumen') ? yes : not;
                    return (
                        <Column
                            flex={conditionalValue(2, 1)}
                            align={conditionalValue('left', 'center')}
                        >
                            <Text text={column} />
                        </Column>
                    );
                })}
            </Row>
            <FlexContainer
                style={{
                    backgroundColor: '#ffffff',
                    margin: '0 5px 5px 5px',
                    borderBottomRightRadius: '3px',
                    borderBottomLeftRadius: '3px',
                }}
                direction='column'
            >
                { map(statuses, ({ key, label }) => (
                    <Row pY={10} mX={15} style={{ borderBottom: '1px solid #e2e2e2' }}>
                        <Column flex={2}>
                            <Text text={label} />
                        </Column>
                        { map(['retiro', 'despacho', 'total'], column => (
                            <Column flex={1} align='center'>
                                <Link target='_blank'
                                    to={{
                                        pathname: '/orders',
                                        search: counterUrl({ id: get(getMobileValues(data), 'id'), row: key, column })
                                    }}
                                >
                                    <CounterButton>
                                        <Text text={`${get(getMobileValues(data), `${column}.${key}`)}`} />
                                    </CounterButton>
                                </Link>
                            </Column>
                        )) }
                    </Row>
                ))}
                <Row pY={10} pX={15}>
                    <Column flex={2}>
                        <Text text='Total' strong />
                    </Column>
                    { map([null, null, get(getMobileValues(data), `total.total`)], text => (
                        <Column flex={1} align='center'>
                            { text && (
                                <Link target='_blank'
                                    to={{
                                        pathname: '/orders',
                                        search: counterUrl({ id: get(getMobileValues(data), 'id'), row: 'resume', column: 'total' })
                                    }}
                                >
                                    <CounterButton>
                                        <Text text={`${text}`} strong />
                                    </CounterButton>
                                </Link>
                            )}
                        </Column>
                    )) }
                </Row>
            </FlexContainer>
        </FlexContainer>
    );
};

SlaCardMobile.propTypes = {
    data: object
};

SlaCardMobile.defaultProps = {
    data: {}
};

export default SlaCardMobile;
